export const CONTACT = {
  phone: "813-534-0090",
  phoneHref: "tel:8135340090",
  email: "palaceofflavor@gmail.com",
  emailHref: "mailto:palaceofflavor@gmail.com",
  area: "Tampa & Surrounding Areas",
  facebook: "https://www.facebook.com/profile.php?id=61592253675521&sk=directory_category",
  instagram: "https://www.instagram.com/palaceofflavor/",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Menu", to: "/menu" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const MENU = [
  {
    category: "Appetizers",
    items: [
      { name: "Vegetable Samosa", desc: "Crisp pastry, spiced potato & peas, tamarind chutney", price: "$8", img: "https://images.unsplash.com/photo-1617692855027-33b14f061079?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Tandoori Chicken Tikka", desc: "Clay-oven charred, yogurt & saffron marinade", price: "$14", img: "https://images.unsplash.com/photo-1563310761-f8d8ed164063?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Paneer Pakora", desc: "Golden gram-flour fritters, mint chutney", price: "$10", img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
    ],
  },
  {
    category: "Signature Mains",
    items: [
      { name: "Hyderabadi Dum Biryani", desc: "Aged basmati, slow-cooked, whole spices & mint", price: "$22", img: "https://images.unsplash.com/photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Butter Chicken", desc: "Velvet tomato gravy, fenugreek, cultured butter", price: "$20", img: "https://images.unsplash.com/photo-1606471191009-63994c53433b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Dal Makhani", desc: "Black lentils simmered overnight, cream & clove", price: "$16", img: "https://images.unsplash.com/photo-1710091691780-c7eb0dc50cf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Rogan Josh", desc: "Kashmiri lamb, ratanjot, aromatic red spice", price: "$24", img: "https://images.unsplash.com/photo-1505253758473-96b7015fcd40?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
    ],
  },
  {
    category: "Breads & Desserts",
    items: [
      { name: "Garlic Butter Naan", desc: "Tandoor-baked, cultured butter, fresh garlic", price: "$5", img: "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
      { name: "Gulab Jamun", desc: "Warm milk dumplings, cardamom & rose syrup", price: "$8", img: "https://images.unsplash.com/photo-1631515242808-497c3fbd3972?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
    ],
  },
];

export const SERVICES = [
  {
    title: "Weddings",
    tone: "magenta",
    desc: "Grand multi-course feasts, live tandoor stations and royal thali service for the most important day of your life.",
    features: ["Live cooking stations", "Custom regional menus", "Full-service staff"],
    img: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Corporate",
    tone: "teal",
    desc: "Polished, punctual catering for boardrooms, launches and conferences across the Tampa Bay area.",
    features: ["Boxed & buffet options", "On-time delivery", "Dietary accommodations"],
    img: "https://images.unsplash.com/photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Private Parties",
    tone: "emerald",
    desc: "Intimate dinners, birthdays and festivals brought to life with authentic home-style Indian flavor.",
    features: ["Chef-hosted dinners", "Festival specials", "Flexible guest counts"],
    img: "https://images.unsplash.com/photo-1629961126387-0dcbfea19a94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const GALLERY = [
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_indian-feast-16/artifacts/ta2v0ou6_504978910_3032843973549145_3568019240067634749_n.webp", span: "md:col-span-2 md:row-span-2", label: "Signature Feast" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_indian-feast-16/artifacts/64l3lh14_504835956_3032843986882477_4720610859002808615_n.webp", span: "md:col-span-2", label: "Freshly Prepared" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_indian-feast-16/artifacts/nba0l5si_504634145_3032843693549173_2615532185630268166_n.webp", span: "md:col-span-2", label: "Catering Trays" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_indian-feast-16/artifacts/lqmd3u0q_504964211_3032843936882482_332730853131327426_n.webp", span: "md:col-span-2", label: "Ready to Serve" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_indian-feast-16/artifacts/fptoucbn_504967525_3032844343549108_7275443682946135145_n.jpg", span: "md:col-span-2", label: "Happy Guests" },
];

export const EVENT_TYPES = ["Wedding", "Corporate Event", "Private Party", "Festival / Religious", "Other"];

export const CATEGORY_OPTIONS = [
  "Appetizers",
  "Vegetable Entree",
  "Chicken Entree",
  "Beef Entree",
  "Lamb / Goat Entree",
  "Seafood Entree",
  "Biryani & Rice",
  "Breads",
  "Desserts",
];

export const TRAY_INFO = {
  half: "Half Tray · serves 8–10 guests",
  full: "Full Tray · serves 18–20 guests",
};

export const CATERING_MENU = [
  {
    category: "Appetizers & Starters",
    img: "https://images.unsplash.com/photo-1617692855027-33b14f061079?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      { name: "Vegetable Samosa", desc: "Crisp pastry, spiced potato & peas, tamarind chutney", half: "$45", full: "$80" },
      { name: "Onion & Spinach Pakora", desc: "Golden gram-flour fritters, mint chutney", half: "$40", full: "$70" },
      { name: "Paneer Tikka", desc: "Char-grilled cottage cheese, bell pepper, onion", half: "$65", full: "$115" },
      { name: "Chicken Tikka", desc: "Clay-oven charred, yogurt & saffron marinade", half: "$70", full: "$125" },
    ],
  },
  {
    category: "Vegetarian Mains",
    img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      { name: "Dal Makhani", desc: "Black lentils simmered overnight, cream & clove", half: "$50", full: "$90" },
      { name: "Paneer Butter Masala", desc: "Cottage cheese in velvet tomato-cashew gravy", half: "$60", full: "$110" },
      { name: "Chana Masala", desc: "Chickpeas, onion-tomato masala, warm spices", half: "$45", full: "$85" },
      { name: "Palak Paneer", desc: "Creamed spinach, paneer, garlic & cumin", half: "$58", full: "$105" },
      { name: "Aloo Gobi", desc: "Potato & cauliflower, turmeric, ginger", half: "$45", full: "$80" },
    ],
  },
  {
    category: "Signature Non-Veg Mains",
    img: "https://images.unsplash.com/photo-1606471191009-63994c53433b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      { name: "Butter Chicken", desc: "Velvet tomato gravy, fenugreek, cultured butter", half: "$70", full: "$130" },
      { name: "Chicken Tikka Masala", desc: "Char-grilled chicken, creamy spiced gravy", half: "$70", full: "$130" },
      { name: "Lamb Rogan Josh", desc: "Kashmiri lamb, ratanjot, aromatic red spice", half: "$85", full: "$155" },
      { name: "Goat Curry", desc: "Bone-in goat, slow-cooked home-style masala", half: "$90", full: "$165" },
    ],
  },
  {
    category: "Biryani & Rice",
    img: "https://images.unsplash.com/photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      { name: "Vegetable Dum Biryani", desc: "Aged basmati, seasonal vegetables, whole spices", half: "$50", full: "$90" },
      { name: "Chicken Dum Biryani", desc: "Hyderabadi style, saffron, fried onion, mint", half: "$65", full: "$120" },
      { name: "Goat Dum Biryani", desc: "Slow-cooked goat, layered basmati, whole spice", half: "$85", full: "$155" },
      { name: "Jeera / Basmati Rice", desc: "Fragrant cumin-tempered long grain rice", half: "$30", full: "$55" },
    ],
  },
  {
    category: "Breads & Desserts",
    img: "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      { name: "Garlic Butter Naan", desc: "Tandoor-baked, cultured butter, fresh garlic (per dozen)", half: "$24", full: "$44" },
      { name: "Tandoori Roti", desc: "Whole-wheat flatbread, clay-oven baked (per dozen)", half: "$20", full: "$36" },
      { name: "Gulab Jamun", desc: "Warm milk dumplings, cardamom & rose syrup", half: "$35", full: "$62" },
      { name: "Rice Kheer", desc: "Slow-cooked rice pudding, saffron, pistachio", half: "$35", full: "$62" },
    ],
  },
];
